<template>
  <v-container fluid class="pa-5">
    <v-layout row wrap justify-space-between align-center mb-3>
      <v-flex md9>
        <h4 class="headline">Encuestas de satisfacción</h4>
      </v-flex>
      <v-flex md3 text-xs-right>
        <v-btn class="k-orange-linear mr-0" @click="createSurvey">Crear encuesta</v-btn>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <data-table
          ref="surveyTable"
          url="surveys"
          @items-reload="surveys = $event">
          <template slot="content" v-for="(survey, i) in surveys">
            <v-list-tile
              :key="`survey-${survey.id}`"
              @click="editSurvey(survey)"
              avatar
            >
              <v-list-tile-avatar>
                <v-icon class="k-orange-linear-text" large>fas fa-clipboard-list</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>
                  <strong>{{ survey.name }}</strong>
                </v-list-tile-title>
              </v-list-tile-content>
              <v-spacer></v-spacer>
              <v-chip v-if="survey.inbound" medium class="green lighten-2 white--text" style="min-width: 110px; justify-content: center">
                <v-icon class="pr-2 white--text" style="font-size: 14px">fas fa-phone-volume</v-icon>
                Inbound
              </v-chip>
              <v-chip v-if="survey.manual && isBanamex" medium class="blue lighten-2 white--text" style="min-width: 110px; justify-content: center">
                <v-icon class="pr-2 white--text" style="font-size: 14px">fas fa-phone</v-icon>
                Manuales
              </v-chip>
              <v-list-tile-action>
                <v-menu bottom offset-y @click.native.stop>
                  <v-btn slot="activator" color="grey darken-2" small flat fab>
                    <v-icon>fas fa-ellipsis-v</v-icon>
                  </v-btn>
                  <v-list>
                    <v-list-tile @click="deleteSurvey(survey)">
                      <v-list-tile-title>Eliminar</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </v-list-tile-action>
            </v-list-tile>
            <v-divider v-if="i !== surveys.length - 1" :key="`divider${i}`" />
          </template>
        </data-table>
      </v-flex>
    </v-layout>
    <survey-dialog
      :show="surveyDialog"
      :survey="survey"
      @created="surveyCreated"
      @updated="surveyUpdated"
      @close="closeDialog"
    />
    <delete-dialog
      :show="deleteDialog"
      :survey="survey"
      @deleted="surveyDeleted"
      @close="deleteDialog = false"
    />
  </v-container>
</template>
  
<script>
import DataTable from '@/components/global/DataTable2';
import SurveyDialog from '@/components/Surveys/Dialog';
import DeleteDialog from '@/components/Surveys/DeleteDialog';

export default {
  components: {
    DataTable,
    SurveyDialog,
    DeleteDialog,
  },
  data() {
    return {
      surveyDialog: false,
      deleteDialog: false,
      survey: {},
      surveys: [],
    };
  },
  computed: {
    isBanamex() {
      return Number(this.$auth.user().company_id) === 86496225;
    },
  },
  methods: {
    closeDialog() {
      this.surveyDialog = false;
    },
    createSurvey() {
      this.survey = {};
      this.surveyDialog = true;
    },
    surveyCreated(data) {
      this.surveys.push(data);
      this.surveyDialog = false;
      this.$refs.surveyTable.$emit('update');
    },
    editSurvey(survey) {
      this.survey = survey;
      this.surveyDialog = true;
    },
    deleteSurvey(survey) {
      this.survey = survey;
      this.deleteDialog = true;
    },
    surveyUpdated(survey) {
      const index = this.surveys.findIndex(item => item.id === survey.id);
      this.$set(this.surveys, index, survey);
      this.surveyDialog = false;
      this.$refs.surveyTable.$emit('update');
    },
    surveyDeleted() {
      this.$refs.surveyTable.$emit('update');
      this.deleteDialog = false;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Surveys/Index.vue